{
  "return_home": "Return home",
  "aria": {
    "rename_schedule": "Rename schedule",
    "change_schedule": "Change schedule"
  },
  "readonly": {
    "agendahero": "agendahero",
    "tagline": "Make any schedule. Share it with anyone.",
    "gallery": "Gallery"
  },
  "schedule": {
    "schedule_picker": {
      "my_schedules": "My schedules",
      "shared_schedules": "Shared with me",
      "create": "Create"
    },
    "delete_confirm": {
      "title": "Delete {{title}}?",
      "submit": "Yes, delete",
      "error_toast": "Error deleting schedule"
    },
    "shared_users_stack": {
      "aria": "Shared users"
    },
    "toolbar": {
      "dashboard": "Dashboard",
      "schedule": "Schedule",
      "sources": "Sources",
      "messages": "Text messages",
      "snippets": "Snippets",
      "more": "More",
      "settings": "Settings",
      "leave": "Leave schedule",
      "delete": "Delete this schedule",
      "create": "Create a schedule",
      "copy": "Copy this schedule"
    }
  },
  "profile_menu": {
    "aria_label": "Profile menu",
    "profile": "Profile",
    "settings": "Settings"
  }
}
